import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=01803dc0&"
import script from "./broadcast.vue?vue&type=script&lang=ts&"
export * from "./broadcast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports